module.exports = __webpack_public_path__ + "static/img/content1.0f37b23e.png";